import type { PatientListQuery } from '@ctms/contracts';

export const patientQueryKeys = {
  all: ['patients'] as const,
  lists: () => [...patientQueryKeys.all, 'list'] as const,
  list: (filters: PatientListQuery) => [...patientQueryKeys.lists(), filters] as const,
  details: () => [...patientQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...patientQueryKeys.details(), id] as const,
  /** Participation history of one chart with the nested visit schedules (elements 6 and 9). */
  enrollments: (id: number) => [...patientQueryKeys.all, 'enrollments', id] as const,
  allEnrollments: () => [...patientQueryKeys.all, 'enrollments'] as const,
  /** Qualification dialog of one participation (issue #30). */
  qualification: (id: number, enrollmentId: number) =>
    [...patientQueryKeys.all, 'qualification', id, enrollmentId] as const,
  /** Participation decisions panel of one enrollment (issue #29). */
  decisions: (id: number, enrollmentId: number) =>
    [...patientQueryKeys.all, 'decisions', id, enrollmentId] as const,
  /** Manual schedule change log of one participation (issue #29 B6/B7). */
  scheduleLog: (id: number, enrollmentId: number) =>
    [...patientQueryKeys.all, 'schedule-log', id, enrollmentId] as const,
  /** „Wizyty szablonowe" dialog state of one participation (issue #41). */
  templateVisits: (id: number, enrollmentId: number) =>
    [...patientQueryKeys.all, 'template-visits', id, enrollmentId] as const,
};
